function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOfficeAddinLogin = function SvgOfficeAddinLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 548.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 367.52,
    cy: 253.25,
    r: 252.15,
    style: {
      fill: "#f6f6fb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.51,
    y: 108.21,
    width: 288.02,
    height: 75.94,
    rx: 4.41,
    style: {
      fill: "#949ca8",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.51,
    y: 311.82,
    width: 288.02,
    height: 75.94,
    rx: 4.41,
    style: {
      fill: "none",
      stroke: "#949ca8",
      strokeMiterlimit: 10,
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.51,
    y: 100.96,
    width: 288.02,
    height: 75.94,
    rx: 4.41,
    transform: "translate(-2.16 5.86) rotate(-0.91)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.94,
    y: 118.83,
    width: 42.55,
    height: 42.55,
    rx: 2.05,
    transform: "translate(-3.57 6.84) rotate(-1.5)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,132.39l.55,21.05a2.18,2.18,0,0,1-2.13,2.23h0l-18.81.5a2.18,2.18,0,0,1-2.24-2.13h0L249,126.52a2.18,2.18,0,0,1,2.13-2.23h0L262.8,124Z",
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.23,132.54l7.12-.19L262.76,124l.17,6.37A2.25,2.25,0,0,0,265.23,132.54Z",
    style: {
      fill: "#54d388"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82,126.28l.11,4.07a2.25,2.25,0,0,0,2.3,2.19l2.9-.08",
    style: {
      fill: "none",
      stroke: "#1c8f5a",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.5,
    y: 120.93,
    width: 85.31,
    height: 9.89,
    rx: 3.31,
    transform: "translate(-3.17 8.69) rotate(-1.5)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.9,
    y: 137.93,
    width: 112.21,
    height: 6.37,
    rx: 2.14,
    transform: "translate(-3.57 9.05) rotate(-1.5)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.2,
    y: 149.67,
    width: 66.78,
    height: 6.37,
    rx: 2.14,
    transform: "translate(-3.88 8.47) rotate(-1.5)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.25,184.65a3.73,3.73,0,0,1-7.46,0Z",
    style: {
      fill: "#d8dae1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.79,210a3.73,3.73,0,0,1,7.46,0Z",
    style: {
      fill: "#d8dae1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.25,286a3.73,3.73,0,0,1-7.46,0Z",
    style: {
      fill: "#d8dae1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.79,311.27a3.73,3.73,0,0,1,7.46,0Z",
    style: {
      fill: "#d8dae1"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.52,
    y1: 188.38,
    x2: 367.52,
    y2: 311.27,
    style: {
      fill: "none",
      stroke: "#d8dae1",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.51,
    y: 209.99,
    width: 288.02,
    height: 75.94,
    rx: 4.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 226.57,
    width: 42.55,
    height: 42.55,
    rx: 2.05,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.81,
    y: 230.52,
    width: 85.31,
    height: 9.89,
    rx: 3.31,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.81,
    y: 247.88,
    width: 112.21,
    height: 6.37,
    rx: 2.14,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.81,
    y: 259.03,
    width: 66.78,
    height: 6.37,
    rx: 2.14,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.37 242.44 265.08 249.4 262.73 252.5 262.73 262.22 256.85 259.04 256.85 252.5 254.5 249.4 249.21 242.44 270.37 242.44",
    style: {
      fill: "#acc0cc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.97,
    y: 236.57,
    width: 25.65,
    height: 5.88,
    rx: 2.75,
    style: {
      fill: "#7c909b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,456.38v86.7a2.2,2.2,0,0,0,4.22,1l38.36-85.51a2.33,2.33,0,0,0-1.93-3.32l-38.37-1.2A2.27,2.27,0,0,0,87,456.38Z",
    style: {
      fill: "none",
      stroke: "#1b1e27",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.61,456.38v86.7a2.2,2.2,0,0,1-4.22,1L120,458.57a2.33,2.33,0,0,1,1.94-3.32l38.37-1.2A2.28,2.28,0,0,1,162.61,456.38Z",
    style: {
      fill: "none",
      stroke: "#1b1e27",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.39 440.57 77.01 456.71 169.62 457.51 172.18 441.54 75.39 440.57",
    style: {
      fill: "#676e7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.64,136.2c.39-1.22,6.06-11.23,9.83-16.85s4.57-8.2,5.76-6.15.42,8.94-.65,13.46-3.93,11.11-8.6,13.42S224.64,136.2,224.64,136.2Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75,134.67s8.85-7.65,10.84-8.22,2.88.61,1.57,3.83-10.25,12.34-14.88,9.13A11.32,11.32,0,0,1,231.75,134.67Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,134.53S200.24,151.22,197.41,153s-14.18,6.74-15.13,8.26-2.11,11.87,3.39,11.59,19.22-7.14,26.35-12.67,19.29-20.44,19.29-20.44Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.91,142.94c.32.22,32.16,6.43,36,5.43s7.36-2.26,7.36-2.26,6.53,18.06,7.16,20.17,4.83,27.73,3.36,30.46-8.66,0-8.66,0l-43.86-47.69Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.89,121.78s4.23-9,4.54-12.29,1.06-4.62,2.25-4,1.9,5.36,1.89,8.62a62.23,62.23,0,0,1-1.36,9.44Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.91,392.26s-.21,14.92-1,20.18-2.52,16-1.89,17,15,3,16,0,6.72-32.59,6.72-32.59Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.26 376.71 58.22 370.3 60.16 357.9 41.88 360.58 32.37 367.35 36.26 376.71",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.12 113.03 148.38 127.36 161.14 129.38 161.5 116.97 152.12 113.03",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.2,
    cy: 102.46,
    r: 17.89,
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,102.46c.53-.21,6-.21,6.83,1.16s-4.79,16.55-20.67,16.73Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,86.28s1.74,3.16-6.93,7.1-16,5.24-22.5,4L139.3,98.5s-2.19-16.37,13.52-17.91C152.82,80.59,166.18,71.85,173.46,86.28Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.92,95.5s-2.94,7.15-4.93,9.35l-1.58,1.58s-.63-3.2-2.16-4c0,0-2.78-2.43-5.51-.25a4.45,4.45,0,0,1,0-4.6C141.21,95.19,153.92,95.5,153.92,95.5Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,101.46c-.42-2.3-4.35-4.15-6.06-5.36A24.44,24.44,0,0,0,123.6,92a31.68,31.68,0,0,0-6.81-.2,18.36,18.36,0,0,0-8,2.7c-4.17,2.45-5.86,6.21-6,10.95-.14,4,1.5,6.52,3.74,9.68,1.76,2.49,4.45,3.73,7.14,5,5.73,2.74,12.35,3.11,18-.38C137.85,115.9,139.25,108.37,140,101.46Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.85,135.81s-1.22-8.88-18.47-9.59c0,0-7.29,2.66-11.32,6.44s-6.35,10.92-6.35,15.55,1.26,8.61-3,23.32S111,197.58,109.28,204.1s7.56,10.92,16,11.55c0,0-2.3-5.46,12.72-4.83s24.89,4.2,28.89,7.14v5.47l3.65,1.38a3.1,3.1,0,0,0,4.2-2.85c.1-6.05.21-17.27-.08-26.69-.42-13.66-2.1-17.44-2.1-17.44S162,152.41,166.85,135.81Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24,215.65s-5.35,9.88-4.41,18.39,5.67,25.53,8.2,34.67,2.2,21.74,2.2,21.74-46.8,86.83-49.32,91.87-1.58,5.36,2.83,8.2,54,21.9,57.2,21.59,2.84-4.73,4.1-9.14,17-82.89,17.34-91.4,3.47-88.14,3.47-88.14V218s-12.6-8.62-35.77-6.91C131.08,211.05,124,211.45,125.24,215.65Z",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47,207.13c14.29-.16,37.61,1.65,54.77,13.19",
    style: {
      fill: "none",
      stroke: "#c3001d",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14,222.17s-4.83,10.08-4.41,20.17,2.19,60.3,2.19,60.3L48.26,336.15S51.7,390.89,53.81,393s8.82-1.26,15.75-4.84,38.87-22.27,38.87-22.27l30-78.37Z",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.27,166.46a8.78,8.78,0,0,0-9,2.34c-4.2,4.2-1.68,13.87,1.26,16s34.88,8.61,52.74,6.93,22.27-2.52,23.32-2.52,9.66-.21,12.61,0,3.57-1.26,6.72-4,9.87-9.06,11.56-9.57-2.32-2.62-6.1-1.36-6.51,2.1-7.77,3.15-7.78,1.6-7.78,1.6-7.35-3.91-9.24-4.54c-2.52,1.26-9.67,6.93-9.67,6.93l-5.25,1.9Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,427s-6-4.57-9-2.53-1,10.88-1.11,12.45,1.67,4.42,4.78,4.42h38.62c.47,0,11.34.1,13.86-3.05s-3.77-6.09-8.19-6.57-18.78-1.73-21.32-3.15-3.63-3.15-6.94-3.07-3.58,3.56-6.78,4.49S109.17,427,109.17,427Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75,367.39s7.3-1.85,7.56-5.47-7.93-7.5-9.07-8.6-4.49-1.44-6.42,1l-24,30.25c-.29.37-7.13,8.82-6.22,12.76s7.12.83,10.23-2.34,13-13.64,15.72-14.74,4.73-.9,6.72-3.54-.57-5,.7-8.1S41.75,367.39,41.75,367.39Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,230.57s.52,12,4.51,22.06,6.2,45.7,6.2,45.7L99.4,353.8",
    style: {
      fill: "none",
      stroke: "#c67c00",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,107.13c.45-.13,2.23-2.94-.49-5.41s-7.8-1.25-7.54,2.38S140.5,108.47,145.12,107.13Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76,97.82a7.16,7.16,0,0,1,3.6-1.22l.39,4a5,5,0,0,0-1.73,1Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.41,177.52a62,62,0,0,1,4.72-4.83c1.06-.74,3.47-2.95,4.42-1.9s-.95,8.22-.95,8.22Z",
    style: {
      fill: "#dda67c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.72,132.66s-4.58,5.46-3.34,12.61,6.12,20.17,12.82,24.58,34.41,32.15,39.25,35.51,9,5,11.13,1.68,5.69-40.58,5.69-40.58a57.13,57.13,0,0,0-14.71-3.33A59.68,59.68,0,0,1,190,161S168.74,139,164.11,136.23,156.55,130.35,151.72,132.66Z",
    style: {
      fill: "#f04"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.91,
    y: 246.09,
    width: 288.02,
    height: 75.94,
    rx: 4.41,
    transform: "matrix(0.96, 0.28, -0.28, 0.96, 103.37, -148.86)",
    style: {
      fill: "#949ca8",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "570.84 314.57 570.84 365.48 564.66 412.5 567.75 420.41 613.55 420.41 598.8 391.95 608.87 325.76 570.84 314.57",
    style: {
      fill: "#949ca8",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.73,515c.16.63.79,14.82,2.36,15.92s11.35,3.78,12.93,0l1.57-16.55Z",
    style: {
      fill: "#3e8440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.93,515.6c0,.48.47,15.6-2.21,16.39s-10.55.63-10.32,0-4.81-17.65-4.81-17.65Z",
    style: {
      fill: "#3e8440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.06,317.68c-1.51,2.54-3.36,90.66-2.94,96.54s31.09,104.22,31.09,104.22h30.68S613.2,415.9,609,409.18s-3.4-8.82-4-10.08,17-76.49,17-76.49S593.45,290.05,577.06,317.68Z",
    style: {
      fill: "#00cc3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.62,334.48s-14.86,73.82-15,78,70,105.94,70,105.94h17.23S623.22,430.11,605,412.5l-3.53-51.22Z",
    style: {
      fill: "#00cc3e"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.78,
    cy: 154.14,
    r: 18.94,
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.24,150.65c-.44-.4-5.87-2.39-7.21-1.34s-1.29,18.19,14.44,24.17Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.19,164.93c-.52-.26-2.58-4,.54-6.35s8.95.29,8.67,4.57S614.5,167.59,609.19,164.93Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598,138.93c1.85,5,8.72,4.62,11.23,8.82,1.34,2.26,2.62,10.37-.25,12.39,1.84-1.63,3.47-1,6.52-2.14,2.29-.87,4-3.3,4.91-5.47,4.13-9.7-12.86-17.93-19.42-20.34C599.19,132.07,597.29,137.11,598,138.93Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.58,140.41s-1.58,1.36-5.45,1-9.87-1.77-11.7-5.3-.43-10.13,3.83-11.8,9.51-1.65,12.88,1.61,4.43,8.63,3.57,10.55A14.62,14.62,0,0,1,602.58,140.41Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.56,169.65c.21.63.93,14.5.93,14.5h13.78l-1.68-14.5Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.76,179.49a1.26,1.26,0,0,0-1.28-1.09c-3.41.1-13.52.44-13.73,1.14s-1.09,7.33,1.17,8.28,9.56-1.33,10.73-2,3.19-1,3.35-2.61A17.69,17.69,0,0,0,602.76,179.49Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.47,290.25c-14.9,6.94-44,1.27-44,1.27a47.13,47.13,0,0,0-4.3-8.82c-2.67-4.1,4.3-7.26,4.3-7.26S571.91,255,570.65,242s.31-23.95,2.2-35.93a31.91,31.91,0,0,1,1-4.39,47.58,47.58,0,0,0,16-2.17,79.66,79.66,0,0,0,22.54-11.17c1.28,1,2.63,2.18,4.13,3.55,5.91,5.35,5.42,18,3.85,30.57s-6.75,50.74-6.75,50.74l4.77.95s4.18,0,6.39,1.88S618.47,290.25,618.47,290.25Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.51,188s-8.23,1.77-7.32,12.23,19.29,26.61,23.81,30.64,18.25,18.66,23.38,17,9-2.43,7.68-7.67S634.4,204.7,628.71,199,617.6,187.7,610.51,188Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.06,540c.62,1.8-3.45,2.73-9.64,3.12-15.46,1-44.06-1.35-45.41-1.64-1.89-.43-5-.43-6.73-1.27s-1-5,2.1-7.35,11.56-2.11,14.71-1.89,10.51-.84,13.87-1.68,4.84-4.63,8.3-4.63,3.68,1.27,5.15,2.74,3.78,3.78,6.1,1.46,2.3-4,4.82-4.2a3.44,3.44,0,0,1,2.31.51c1.13.74,2,2.3,3.37,5A16.09,16.09,0,0,1,631.06,540Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.52,540c1.21,3.46-15,3.69-30.1,3.12,6.19-.39,10.26-1.32,9.64-3.12a16.09,16.09,0,0,0-1-9.87c-1.34-2.66-2.24-4.22-3.37-5a4.38,4.38,0,0,1,2.08-.51c3.47,0,3.67,1.27,5.15,2.74s3.78,3.78,6.09,1.46,2.31-4,4.83-4.2,3.57,1.27,5.68,5.47A16.25,16.25,0,0,1,651.52,540Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.47,188.38a79.66,79.66,0,0,1-22.54,11.17,47.58,47.58,0,0,1-16,2.17c3.23-9.88,11-17.36,11-17.36a107.92,107.92,0,0,1,15.15-.62A19.4,19.4,0,0,1,612.47,188.38Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.19,180.05s-2.25-.1-3.15.95-2.87,5.09-1.62,5.78,5.4-1.48,5.51-3.1A9.8,9.8,0,0,0,588.19,180.05Z",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.9,201.72s30.45-14.26,32.75-16.75,5-.14,6.7,1.44.62,5.06,0,6.31S586.77,209,573.9,201.72Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.44,403.4l-1.55,4.42A30.26,30.26,0,0,1,605,412.5",
    style: {
      fill: "none",
      stroke: "#3e8440",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.74,202.85s-1.79,2.63-.84,5.15",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.14,200.54a9.41,9.41,0,0,0,1.8,6.09",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.7,194.34c.11.32.63,5.6,2.1,7.42",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586,183.88s-1.36,4.1.64,4.5,5-1.47,5-1.47",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.68,205.43a23.67,23.67,0,0,0,6.6,10.76,87,87,0,0,1,8.46,9.46",
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.81,149.13s3.29-.63,4.7,1.06",
    style: {
      fill: "none",
      stroke: "#d88d6a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.88,153c0,.12-3.6,7-3.6,7l.61.87,3.65-2.54Z",
    style: {
      fill: "#1b1e27"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.61,
    y: 239.01,
    width: 288.02,
    height: 75.94,
    rx: 4.41,
    transform: "translate(101.77 -151.89) rotate(16.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.42,
    y: 225.28,
    width: 42.55,
    height: 42.55,
    rx: 2.05,
    transform: "translate(88.98 -124.05) rotate(16.41)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.91,
    y: 249.86,
    width: 85.31,
    height: 9.89,
    rx: 3.31,
    transform: "translate(94.24 -144.02) rotate(16.41)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.96,
    y: 270.38,
    width: 112.21,
    height: 6.37,
    rx: 2.14,
    transform: "translate(99.88 -145.65) rotate(16.41)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.73,
    y: 274.67,
    width: 66.78,
    height: 6.37,
    rx: 2.14,
    transform: "translate(100.08 -138.43) rotate(16.41)",
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.75,240.81,475,236.18l.17-1.75A2.06,2.06,0,0,0,474,232l-7.21-2.12a2.29,2.29,0,0,0-2.68,1.79l-5.88,20a2.16,2.16,0,0,0,1.34,2.75l25.06,7.38a2.16,2.16,0,0,0,2.62-1.58l4.89-16.62A2.16,2.16,0,0,0,490.75,240.81Z",
    style: {
      fill: "#54d388"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.24,246.45,486.66,262a2.08,2.08,0,0,1-2.58,1.44h0L459,256.05a2.08,2.08,0,0,1-1.39-2.6h0l4.58-15.55a2.08,2.08,0,0,1,2.57-1.44h0l25.05,7.38a2.07,2.07,0,0,1,1.39,2.6Z",
    style: {
      fill: "#1bae5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.8,236.46l25.05,7.38a2.07,2.07,0,0,1,1.39,2.6h0",
    style: {
      fill: "none",
      stroke: "#1c8f5a",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.57,293.7c-.54.13-8.72,10.43-8.93,10.85s-5.36,6.3-3.78,10.29,2.12,13.34,6.21,9.25,12.59-18.18,13.33-22S612.77,293.17,610.57,293.7Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.89,311.3a97.24,97.24,0,0,1-14.07,7.24c-5.68,2.1-3.68,4.73-1.48,5.67a4.32,4.32,0,0,0,3.58,2.8c2.73.25,7.42.88,7.42.88l6-3.68Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.87,300.9s-11.88,6.48-16.74,9.18-4.3,3.38-2.72,3.92,10.3,0,10.3,0Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.88,304.19c-1.5,1.54-5.92.25-6,.21-2.42-1.35-5.15-2.17-7.49-3.71a7.32,7.32,0,0,1-3-6.54c0-1,.72-3.73,1.56-4.43,1.7-1.4,5.49.25,7.14.83,2.71.94,5.46,2,7.43,4.17,1.75,2,2.82,4.54,1.9,7.15A6.37,6.37,0,0,1,620.88,304.19Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.72,233.57s-6.62,2.83-7.88,7.88S604,292.19,607.11,295.66s10.08,7.24,12.6,5.35,37.51-53.22,38.45-56.55S655.64,229.79,642.72,233.57Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,303l-4.76-1.87-2-11.27a6,6,0,0,0-.78-1.57,3.59,3.59,0,0,0-3.05-1.69h0s-1.86-3.91-3.59-3.54-3.58,3.83-3.21,6.55.62,7.91,2,10.14,2.59,3.29,4.32,3.25,1.86.45,3.34,1.07a11.92,11.92,0,0,0,5.59,0C530.28,303.8,532,303,532,303Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.52,300.73a3.18,3.18,0,0,1-3.56-1.18c-1.25-1.94-3.89-12.45-1.43-12s2.37,1,2.37,1Z",
    style: {
      fill: "#f5bc9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.84,220.81s-9.24,11.87-8.82,12,8.22,2.68,8.22,2.68Z",
    style: {
      fill: "#2979ff"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfficeAddinLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/office-addin-login.75aaa196.svg";
export { ForwardRef as ReactComponent };